var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',_vm._g(_vm._b({attrs:{"dense":""}},'v-row',_vm.$attrs,false),_vm.$listeners),[_vm._l((_vm.getRows),function(q){return _c('v-col',_vm._b({key:q},'v-col',_vm.COL_SIZES,false),[_c('v-sheet',[_c('v-skeleton-loader',_vm._b({attrs:{"type":_vm.type}},'v-skeleton-loader',_vm.$attrs,false))],1)],1)}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }